import React from 'react';
import css from './index.css';
import ToolTip from '~/components/common/ToolTip';
import accounting from '~/misc/accounting';
import { Type as LoadsType } from '~/misc/loadTypes'
import cs from 'classnames';
const config = { 
  [LoadsType.BID]: {
    type:"bid",
    tip:"BID | This is a biddable load. Make an offer now!",
    suffix: 'bid'
  },
  [LoadsType.BOOKING]:{
    type:"booking",
    tip:"BOOK | Book this load instantly!",
    suffix: 'booking'
  },
  [LoadsType.NORMAL]: {
    type: "normal",
    tip:"",
    suffix: 'normal'
  }
}

const PriceWithIcon = ({price, type: inType}) => {
  if(!price) return (
    <div className={css.wrap}>
      <div className={cs(
        css.icon,
      )}>
      </div>
      <div className={cs(
        css.price,
      )}> 
        - -
      </div>
    </div>
  )
  const { tip, suffix, type } = config[inType] || config['normal'];
  const [tipTitle, tipContent] = tip ? tip.split('|') : ['','']
  const priceBlock = (
    <div className={css.wrap}>
      <div className={cs(
        css.icon,
        css['icon-'+suffix]
      )}>
      </div>
      <div className={cs(
        css.price,
        css['price-'+suffix]
      )}> 
        { accounting.formatMoney(price) }
      </div>
    </div>
  )
  return (
  <div className={css.tooltipWarp}>
    <ToolTip
      trigger={priceBlock}
      disabled={!tip}
    >
      <div className={css.tipWarp}>
        {/* <div className={css.tipTitle}>{tipTitle}</div> */}
        <div className={css.tipContent}>{tipContent}</div>
      </div>
    </ToolTip>
  </div>
  
  )
}

export default PriceWithIcon;


// WEBPACK FOOTER //
// ./src/components/common/PriceWithType/index.js